import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ruCommon from './locales/ru/common.json';
import cnCommon from './locales/cn/common.json';

const usedNamespaces = new Set(['common']);

export const registerNamespace = (ns = 'common') => {
  usedNamespaces.add(ns);
};

export const loadNamespace = async (lng, ns) => {
  if (!i18n.hasResourceBundle(lng, ns)) {
    try {
      const module = await import(`./locales/${lng}/${ns}.json`);
      const translations = module.default || module;
      i18n.addResourceBundle(lng, translations);
    } catch (err) {
      console.error(`error ${lng}.${ns}:`, err);
    }
  }
};

export const loadRequiredNamespaces = async (lng) => {
  const toLoad = ['common'];

  if (toLoad.length > 0) {
    await Promise.all(toLoad.map((ns) => loadNamespace(lng, ns)));
  }
};

i18n.use(initReactI18next).init({
  resources: {
    ru: { common: ruCommon },
    cn: { common: cnCommon },
  },
  lng: localStorage.getItem('locale') || 'cn',
  fallbackLng: localStorage.getItem('locale') || 'cn',
  ns: ['common'],
  defaultNS: 'common',
  fallbackNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
    wait: false,
  },
  partialBundledLanguages: true,
});

i18n.on('failedLoading', (lng, ns, msg) => {
  console.error(`Ошибка в языке.ns ${lng}.${ns}:`, msg);
});

export default i18n;
